// extracted by mini-css-extract-plugin
export var noScroll = "ScrollableTabs-module--noScroll--6caa4";
export var scrollRightButton = "ScrollableTabs-module--scrollRightButton--f7659";
export var scrollWrapper = "ScrollableTabs-module--scrollWrapper--46495";
export var tabs = "ScrollableTabs-module--tabs--41bcb";
export var tabsOverflow = "ScrollableTabs-module--tabsOverflow--791dd";
export var tabsWithArrow = "ScrollableTabs-module--tabsWithArrow--ee75a";